export default () => {
  const data = {
    event_name: 'click',
    button_name: 'search_properties',
    page_section: 'search_properties',
    name_of_the_page_viewed: 'home_personal',
  };
  return data;
};
